import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { PageHeader, Loading } from "../components/PageHeader";
import { OrderDetails } from "../components/OrderDetails";

export default function OrderPage() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const t = params.get("t");
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/orders/${id}`, { params: t ? { t } : {} }).then((r) => setOrder(r.data)).catch((e) => setErr(errMsg(e)));
  }, [id, t]);
  return (
    <div data-testid="order-page">
      <PageHeader eyebrow="Order" title="Your order" />
      <div className="wb-container">
        {err ? <p className="text-red-400" data-testid="order-error">{err}</p> : !order ? <Loading /> : (
          order.status === "pending"
            ? <p className="muted" data-testid="order-pending">This order is awaiting payment.</p>
            : <OrderDetails order={order} token={t} />
        )}
      </div>
    </div>
  );
}
